<template>
  <div class="content-padding">
    <v-form>
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>{{$t('entity.retentionCertificate')}}</v-toolbar-title>
        </v-toolbar>
        <v-progress-linear v-if="loading" v-bind:indeterminate="true"></v-progress-linear>

        <v-data-table
          v-bind:headers="headers"
          :items="items"
          hide-default-footer
          no-data-text="No se encontró información"
        >
          <template v-slot:item.print="{item}">
            <div class="btn-group">
              <v-btn @click="getSignedUrl(item.retentionCertificateUri)" icon>
                <v-icon>print</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:item.retentionCertificateDate="{item}">
            <v-row>
              <v-col>{{ item.retentionCertificateDate | formatToDate}}</v-col>
            </v-row>
          </template>
          <template v-slot:item.retentionCertificateSentAt="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">send</v-icon>
              </template>
              <span>Enviado: {{ item.retentionCertificateSentAt | formatToDate}}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { i18n } from "@/i18n";
import { responseException } from "@/assets/js/common";
import { getToken } from "@/assets/js/shared/utils.js";
export default {
  data() {
    return {
      loading: false,
      headers: [
        {
          text: i18n.tc("action", 2),
          value: "print",
          align: "center",
          sortable: false
        },
        {
          text: i18n.t("issued"),
          align: "center",
          value: "retentionCertificateDate",
          sortable: false
        },
        {
          text: i18n.t("detail"),
          align: "center",
          value: "retentionCertificateSentAt",
          sortable: false,
          class: "hidden-xs-only"
        }
      ],
      items: [],
      dialog: false,
    };
  },
  methods: {
    get: function() {
      this.loading = true;
      this.$http
        .get(
          `common/people/${getToken().personId}/retentioncertificates/ispublic`
        )
        .then(
          response => {
            // console.log('certi >>> ', response.body);
            this.items = response.body;
            this.loading = false;
          },
          response => {
            this.$swal({
              icon: 'error',
              title: this.$t('errorOcurred'),
              text: responseException(response)
            });
            this.loading = false;
          }
        );
    },
    getSignedUrl: function (url) {
      this.$http.get(`common/attachments/signed?url=${url}&redirect=false`)
      .then(response => {
          window.open(response.body, '_blank');
        },
        response => {
          this.$swal({
            icon: 'error',
            title: this.$t('errorOcurred'),
            text: responseException(response)
          });
          this.loading = false;
        }
      );
    }
  },
  mounted: function() {
    this.get();
  }
};
</script>
